import { Component, OnInit, Input, Inject } from '@angular/core';
import {MatBottomSheetRef} from '@angular/material/bottom-sheet';
import {MAT_BOTTOM_SHEET_DATA} from '@angular/material/bottom-sheet';
import {MatSnackBar, MatSnackBarConfig} from '@angular/material/snack-bar';
import {Clipboard} from '@angular/cdk/clipboard';

@Component({
  selector: 'app-share-bottomsheet',
  templateUrl: './share-bottomsheet.component.html',
  styleUrls: ['./share-bottomsheet.component.scss']
})
export class ShareBottomsheetComponent implements OnInit {

  //link = "test332";

  @Input() link: {fb:string,twitter:string,whatsapp:string};

  constructor(private _bottomSheetRef: MatBottomSheetRef<ShareBottomsheetComponent>,
     @Inject(MAT_BOTTOM_SHEET_DATA) public data: any,
     private clipboard: Clipboard, 
     private _snackBar: MatSnackBar) { }

  ngOnInit(): void {
    //console.log(this.data.link);
    this.link = this.data.link;

  }

  copyLink(){
    this.clipboard.copy(this.data.fullUrl);
    this._bottomSheetRef.dismiss();
    this.openSnackBar('Copied To Clipboard','Close');
    //return this.data;
  }

  openWhatsapp(){
    window.open(this.link.whatsapp);
    this._bottomSheetRef.dismiss();
  }
  openFacebook(){
    window.open(this.link.fb);
    this._bottomSheetRef.dismiss();
  }
  openTwitter(){
    window.open(this.link.twitter);
    this._bottomSheetRef.dismiss();
  }

  

  openLink(event: MouseEvent): void {
    this._bottomSheetRef.dismiss();
    event.preventDefault();
  }

  openSnackBar(message: string, action: string) {
    const config = new MatSnackBarConfig();
    config.panelClass = ['custom-class'];
    config.duration = 2000;
    this._snackBar.open(message, action, config);
  }

}
